import script from "./NewVideoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NewVideoPage.vue?vue&type=script&setup=true&lang=js"

import "./NewVideoPage.vue?vue&type=style&index=0&id=70e0be6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70e0be6c"]])

export default __exports__